import {
  Box,
  useBox,
  Flex,
  useFlex,
  InvalidStateBox,
  ScreenReaderOnly,
} from '@semcore/base-components';
import type { FlexProps, BoxProps } from '@semcore/base-components';

export {
  /**
   * @deprecated Use Box from `@semcore/base-components` instead. Package `@semcore/flex-box` will be removed in the next major release
   */
  Box,
  /**
   * @deprecated Use useBox from `@semcore/base-components` instead. Package `@semcore/flex-box` will be removed in the next major release
   */
  useBox,
  /**
   * @deprecated Use Flex from `@semcore/base-components` instead. Package `@semcore/flex-box` will be removed in the next major release
   */
  Flex,
  /**
   * @deprecated Use useFlex from `@semcore/base-components` instead. Package `@semcore/flex-box` will be removed in the next major release
   */
  useFlex,
  /**
   * @deprecated Use InvalidStateBox from `@semcore/base-components` instead. Package `@semcore/flex-box` will be removed in the next major release
   */
  InvalidStateBox,
  /**
   * @deprecated Use ScreenReaderOnly from `@semcore/base-components` instead. Package `@semcore/flex-box` will be removed in the next major release
   */
  ScreenReaderOnly,
  /**
   * @deprecated Use FlexProps from `@semcore/base-components` instead. Package `@semcore/flex-box` will be removed in the next major release
   */
  type FlexProps,
  /**
   * @deprecated Use BoxProps from `@semcore/base-components` instead. Package `@semcore/flex-box` will be removed in the next major release
   */
  type BoxProps,
};
